import { CHATBOT_ID } from '../../constants/chatbotId';
import { BLOB_ID } from '../../constants/blobId';
import { hostTypeSelector } from '../../selectors/hostTypeSelector';
import { EDeviceType } from '../../types/deviceType';
import { EHostType } from '../../types/hostType';
import { TThunkAction } from '../../types/redux/thunk';
import { buildUrlWithQuery } from '../../utils/buildUrlWithQuery';

export const updateChatIdInUrl =
  (chatId: string | null): TThunkAction<void> =>
  (_dispatch, getState, { custom: { realDevice } }) => {
    const state = getState();
    const hostType = hostTypeSelector(state);

    const queryParams = new URLSearchParams(window.location.search);
    const queryChatId = queryParams.get('chatId');

    if (hostType === EHostType.Frame || chatId === queryChatId || chatId === BLOB_ID || chatId === CHATBOT_ID) {
      return;
    }

    if (chatId && chatId !== queryChatId) {
      queryParams.set('chatId', chatId);

      const newUrl = buildUrlWithQuery(window.location.pathname, queryParams.toString());

      if (realDevice === EDeviceType.Desktop) {
        window.history.replaceState(null, '', newUrl);
      } else {
        window.history.pushState(null, '', newUrl);
      }

      return;
    }

    queryParams.delete('chatId');

    const newUrl = buildUrlWithQuery(window.location.pathname, queryParams.toString());

    window.history.replaceState(null, '', newUrl);
  };
